import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { toggleArray } from '@domain-group/javascript-utils'

import {
  Form, Link, SidebarModalListItem,
} from '@domain-group/suit-theme'

import { CustomDeadlineModel } from '@domain-group/realhub-backend-api-types'

const weekDaysArray = [
  { id: 0, title: 'Sunday' },
  { id: 1, title: 'Monday' },
  { id: 2, title: 'Tuesday' },
  { id: 3, title: 'Wednesday' },
  { id: 4, title: 'Thursday' },
  { id: 5, title: 'Friday' },
  { id: 6, title: 'Saturday' },
]

interface DeadlinesProps {
  entityState: Partial<CustomDeadlineModel>,
  handlers: object,
  setEntityState: Function,
}

const Deadlines = (props: DeadlinesProps) => {
  const {
    entityState: {
      deadline_date,
      deadline_time,
      deadline_type,
      enabled_days = [],
      occurs_daily,
    },
    handlers,
    setEntityState,
  } = props

  const allDaysEnabled = enabled_days.length === weekDaysArray.length

  return (
    <>
      <Form.Row>
        <Form.Field label="* Alert Time" marginTop="large">
          <input name="deadline_time" type="time" value={deadline_time} {...handlers} />
        </Form.Field>

        {deadline_type === 'once' && (
          <Form.Field label="* Alert Date" marginTop="large">
            <input name="deadline_date" type="date" value={deadline_date} {...handlers} />
          </Form.Field>
        )}

        {deadline_type === 'weekly' && (
          <Form.Field label="* Occurs Day" marginTop="large">
            <select
              name="occurs_daily"
              onChange={e => setEntityState({ occurs_daily: e.target.value === 'true' })}
              // @ts-expect-error TS2322
              value={occurs_daily}
            >
              <option value="true">Every Day</option>
              <option value="false">Select Day(s)</option>
            </select>
          </Form.Field>
        )}
      </Form.Row>

      {deadline_type !== 'once' && !occurs_daily && (
        <Form.Field
          direction="column"
          label="* Select Days"
          labelRight={(
            <Link
              onClick={() => setEntityState({ enabled_days: allDaysEnabled ? [] : weekDaysArray.map(day => day.id) })}
              textProps={{ fontSize: 'small' }}
            >
              { allDaysEnabled ? 'Deselect All ' : 'Select All '}
              <FontAwesomeIcon icon={faCheckCircle} />
            </Link>
          )}
          marginTop="large"
        >
          {weekDaysArray.map(day => (
            <SidebarModalListItem
              checkboxOnClick={() => setEntityState({ enabled_days: toggleArray(enabled_days, day.id) })}
              isChecked={enabled_days.includes(day.id)}
              key={day.id}
              showCheckbox
              title={day.title}
            />
          ))}
        </Form.Field>
      )}
    </>
  )
}

export default Deadlines
